(function () {
  function money(c) { return '£' + (c / 100).toFixed(2); }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- Format and pouches per can, read from the spec table in the description ---------- */
  function specs() {
    var out = {};
    $$('table tr').forEach(function (tr) {
      var c = tr.querySelectorAll('td, th');
      if (c.length !== 2) return;
      var k = c[0].textContent.replace(/[:\s]+$/, '').trim().toLowerCase();
      var v = c[1].textContent.replace(/\s+/g, ' ').trim();
      if (k && v && v.length < 60 && !out[k]) out[k] = v;
    });
    return out;
  }
  function fillAttrs() {
    var box = $('[data-bnp-attrs]');
    if (!box) return;
    var s = specs();
    var fmt = s['format'] || s['pouch format'];
    var cnt = s['pouches'] || s['pouches per can'];
    var per = s['nicotine/pouch'] || s['nicotine per pouch'];
    if (fmt) {
      fmt = fmt.replace(/\s*\/\s*/g, ', ').replace(/all[- ]white/i, 'all white');
      var f = $('[data-bnp-format]', box); $('.bnp-attr__value', f).textContent = fmt.split(',')[0]; f.hidden = false;
    }
    if (cnt) {
      var m = cnt.match(/\d+/);
      if (m) { var c = $('[data-bnp-count]', box); $('.bnp-attr__value', c).textContent = m[0] + ' pouches'; c.hidden = false; }
    }
    var mg = $('[data-bnp-mg]', box);
    if (mg && per && /\d/.test(per)) mg.textContent = per.replace(/\s*mg/i, 'mg') + ' per pouch';
  }

  /* ---------- Pack picker from the live Hulk offer ---------- */
  var H = window.hulkapps || {};
  var API = (H.vd_url || 'https://volumediscount.hulkapps.com') + '/api/v2/shop/get_offer_table';

  function body(el) {
    var pid = el.getAttribute('data-pid'), tags = [];
    try { tags = JSON.parse(el.getAttribute('data-tags') || '[]'); } catch (e) {}
    var p = new URLSearchParams();
    p.append('store_id', H.store_id || '');
    p.append('pid', pid);
    p.append('product_variants', el.getAttribute('data-vids') || '');
    p.append('product_collections', el.getAttribute('data-cols') || '');
    tags.forEach(function (t) { p.append('product_tags[' + pid + '][]', t); });
    p.append('ctags', H.customer && H.customer.tags ? H.customer.tags : '');
    p.append('customer_orders_count', '');
    p.append('geo_country', H.geo_country || '');
    p.append('market_country', H.market_country || '');
    return p.toString();
  }
  function tiers(o, price) {
    if (!o || o.discount_type !== 'each_qty') return [];
    var lv = []; try { lv = JSON.parse(o.offer_levels || '[]'); } catch (e) { return []; }
    var out = [];
    lv.forEach(function (l) {
      var q = parseInt(l[0], 10), v = parseFloat(l[1]), t = String(l[2] || ''), total, off = null;
      if (!(q > 1) || isNaN(v)) return;
      if (t.indexOf('%') > -1) { total = Math.round(price * q * (100 - v) / 100 + 1e-9); off = v; }
      else if (t === 'fix_price') total = Math.round(v * 100) * q;
      else if (/off/i.test(t)) total = (price - Math.round(v * 100)) * q;
      else return;
      if (!(total > 0) || total >= price * q) return;
      out.push({ q: q, total: total, each: Math.round(total / q), off: off, save: price * q - total, pop: String(l[4]) === '1' });
    });
    return out.sort(function (a, b) { return a.q - b.q; });
  }

  var qtyInput, addBtn, addLabel, baseLabel;
  function findForm() {
    qtyInput = $('product-info input.quantity__input[name="quantity"]') || $('input.quantity__input[name="quantity"]');
    addBtn = $('product-info .product-form__submit') || $('.product-form__submit');
    addLabel = addBtn ? (addBtn.querySelector('span') || addBtn) : null;
    if (addLabel && !baseLabel) baseLabel = addLabel.textContent.trim() || 'Add to cart';
  }
  function setQty(q, total) {
    if (qtyInput) {
      qtyInput.value = q;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (addLabel) addLabel.textContent = q > 1 ? 'Add ' + q + ' to cart · ' + money(total) : baseLabel + ' · ' + money(total);
  }

  function renderPacks(el, o) {
    var price = parseInt(el.getAttribute('data-price'), 10);
    var rows = tiers(o, price);
    if (!rows.length) return;
    findForm();
    var last = rows[rows.length - 1];
    var html = card(1, price, price, null, 0, false, false, true);
    rows.forEach(function (r) { html += card(r.q, r.total, r.each, r.off, r.save, rows.length > 1 && r === last, r.pop && r !== last, false); });
    $('.bnp-packs__list', el).innerHTML = html;
    var title = o.offer_title || o.offer_name || '';
    $('.bnp-packs__offer', el).textContent = title;
    el.hidden = false;
    document.documentElement.classList.add('bnp-has-packs');
    setQty(1, price);
    var mix = $('[data-bnp-mix]');
    if (mix) {
      var t = rows.map(function (r) { return r.q + ' for ' + money(r.total) + (r.off ? ' (' + r.off + '% off)' : ''); }).join(', ');
      $('.bnp-mix-text', mix).textContent = (title ? title + ': ' : '') + t + '.';
      mix.hidden = false;
    }
    el.addEventListener('change', function (e) {
      var i = e.target;
      if (!i.matches('input[type=radio]')) return;
      setQty(parseInt(i.value, 10), parseInt(i.getAttribute('data-total'), 10));
    });
  }
  function card(q, total, each, off, save, best, pop, checked) {
    var badge = best ? '<span class="bnp-pk__badge bnp-pk__badge--best">Best value</span>' : (pop ? '<span class="bnp-pk__badge">Most popular</span>' : '');
    var sub = q === 1 ? 'Single can' : (off ? off + '% off every can' : 'Save ' + money(save));
    return '<label class="bnp-pk">' +
      '<input type="radio" name="bnp-pack" value="' + q + '" data-total="' + total + '"' + (checked ? ' checked' : '') + '>' +
      '<span class="bnp-pk__radio" aria-hidden="true"></span>' +
      '<span class="bnp-pk__main"><span class="bnp-pk__name">' + q + ' ' + (q === 1 ? 'can' : 'cans') + badge + '</span><span class="bnp-pk__sub">' + sub + '</span></span>' +
      '<span class="bnp-pk__price"><span class="bnp-pk__total">' + money(total) + '</span>' +
      (q > 1 ? '<s class="bnp-pk__was">' + money(total + save) + '</s>' : '') +
      '<span class="bnp-pk__each">' + money(each) + '/can</span></span></label>';
  }
  function loadPacks() {
    var el = $('[data-bnp-packs]');
    if (!el || !H.store_id) return;
    fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }, body: body(el) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d && d.eligible_offer) renderPacks(el, d.eligible_offer); })
      .catch(function () {});
  }

  /* ---------- Dispatch countdown (UK time, 16:00 Mon to Fri) ---------- */
  function ukNow() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { day: p.weekday, h: parseInt(p.hour, 10), m: parseInt(p.minute, 10) };
  }
  function cutoff() {
    var el = $('[data-bnp-cutoff] span');
    if (!el) return;
    var n = ukNow(), wk = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(n.day) > -1;
    var mins = 16 * 60 - (n.h * 60 + n.m);
    if (wk && mins > 0) {
      var h = Math.floor(mins / 60), m = mins % 60;
      el.innerHTML = 'Order within <strong>' + (h ? h + 'h ' : '') + m + 'm</strong> for dispatch <strong>today</strong>';
    } else {
      var next = { Mon: 'Tuesday', Tue: 'Wednesday', Wed: 'Thursday', Thu: 'Friday', Fri: 'Monday', Sat: 'Monday', Sun: 'Monday' }[n.day];
      el.innerHTML = 'Order now for dispatch on <strong>' + next + '</strong>';
    }
  }

  /* ---------- Free delivery progress from the cart ---------- */
  function progress() {
    var box = $('[data-bnp-deliv]'), pr = $('[data-bnp-progress]');
    if (!box || !pr) return;
    var f48 = parseInt(box.getAttribute('data-free48'), 10), f24 = parseInt(box.getAttribute('data-free24'), 10);
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var t = c.total_price || 0, msg, pct;
      if (t <= 0) { pr.hidden = true; return; }
      if (t < f48) { msg = 'Add <strong>' + money(f48 - t) + '</strong> more for FREE tracked delivery'; pct = t / f48; }
      else if (t < f24) { msg = 'FREE Tracked 48 unlocked. Add <strong>' + money(f24 - t) + '</strong> more for FREE Tracked 24'; pct = t / f24; }
      else { msg = '<strong>FREE Tracked 24 delivery</strong> unlocked'; pct = 1; }
      $('.bnp-deliv__msg', pr).innerHTML = msg;
      $('.bnp-deliv__bar span', pr).style.width = Math.min(100, Math.round(pct * 100)) + '%';
      pr.hidden = false;
    }).catch(function () {});
  }

  function init() {
    fillAttrs();
    loadPacks();
    cutoff(); setInterval(cutoff, 30000);
    progress();
    document.addEventListener('submit', function (e) {
      if (e.target.matches('form[action*="/cart/add"]')) { setTimeout(progress, 1500); setTimeout(progress, 3500); }
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
